import { useQuery } from '@tanstack/react-query'

import { get } from '../apiClient'
import { pincodeResponseSchema } from '../../../common/validations/reservationSchema'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

const params = (
  contractUuid: string,
  contractPartId: number,
  enabled: boolean
) => {
  const path = API_ENDPOINTS.CONTRACT_PART_PINCODE.replace(
    ':contractUuid',
    contractUuid
  ).replace(':contractPartId', contractPartId.toString())

  return {
    queryKey: ['contract-part-pincode', contractUuid, contractPartId],
    queryFn: async () => {
      return get(path, pincodeResponseSchema)
    },
    enabled,
  }
}

export const useAPIGetContractPartPincode = (
  contractUuid: string,
  contractPartId: number,
  enabled: boolean
) => {
  return useQuery(params(contractUuid, contractPartId, enabled))
}
